import React, { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ActivityIndicator } from 'react-native-paper';
import { useGetMyThirdPartyAuths } from '../../apis/appsyncApis';
import { screenNames } from '../../navigators/screenNames';
import { useI18n } from '../../context/I18nContext';
import ScrollablePage from '../../components/ui/ScrollablePage';
import { AppDrawerNavigationProp } from '../../components/DrawerMenuContent';
import { ListItemRow } from '../../components/ListItemRow';
import Container from '../../components/Container';
import GradientButton from '../../components/GradientButton';
import Typography from '../../components/Typography';

const ThirdPartyAuth: React.FC = () => {
  const { bottom } = useSafeAreaInsets();
  const result = useGetMyThirdPartyAuths();
  const data = result.data?.data?.getMyThirdPartyAuths;
  const navigation = useNavigation<AppDrawerNavigationProp>();
  const { I18n } = useI18n();

  const handleAddThirdPartyAuth = useCallback(() => {
    navigation.navigate(screenNames.AddThirdPartyAuth);
  }, [navigation]);

  const renderAuthProviders = () => {
    return data?.length ? (
      data.map((thirdPartyAuth) => {
        return (
          <ListItemRow
            key={thirdPartyAuth?.authProvider}
            title={I18n.t(`thirdPartyAuth.provider.${thirdPartyAuth?.authProvider ?? 'default'}`)}
            leftIcon={{ name: 'shield-account-outline', set: 'material-community' }}
            onPress={() =>
              thirdPartyAuth?.authProvider &&
              navigation.navigate('me', {
                screen: screenNames.ThirdPartyAuthDetail,
                params: { authProvider: thirdPartyAuth.authProvider },
              })
            }
            type="navigation"
          />
        );
      })
    ) : (
      <Typography variant="body1" style={{ paddingHorizontal: 16, paddingVertical: 8, textAlign: 'center' }}>
        {I18n.t('thirdPartyAuth.noThirdPartyAuth')}
      </Typography>
    );
  };

  return (
    <ScrollablePage
      summary={{
        title: I18n.t('thirdPartyAuth.summaryTitle'),
        description: I18n.t('thirdPartyAuth.summaryDescription'),
        icon: 'lock',
      }}
    >
      {result.isLoading ? <ActivityIndicator /> : renderAuthProviders()}
      <Container style={{ flex: 0, marginBottom: Math.max(bottom, 16), marginTop: 16 }}>
        <GradientButton onPress={handleAddThirdPartyAuth} icon={'plus'}>
          {I18n.t('thirdPartyAuth.addThirdPartyAuth')}
        </GradientButton>
      </Container>
    </ScrollablePage>
  );
};

export default ThirdPartyAuth;
